<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    @ok="handleOk"
    :closable="true"
    @close="handleCancel"
    cancelText="关闭">
    <div @click="contentTap">
      <a-spin :spinning="confirmLoading" >
        <a-form-model ref="form" :model="model" :rules="validatorRules">
          <a-row class="form-box">
            <a-col :span="24">
              <a-form-model-item  label="模板名称" required prop="templateName">
                <a-input  v-model="model.templateName" placeholder="请输入模板名称"  ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item  label="模板内容" required prop="content">
                <div @click.stop="" ref="toolRef" class="question-tool">
                  <a-cascader :options="toolList" expandTrigger="hover" @change="toolChange">
                    <span style="cursor: pointer" class="tit" href="#"><img src="../../../../assets/dot.png">引用</span>
                  </a-cascader>
                </div>
                <div @click.stop="" ref="titleRef">
                  <a-textarea   v-model="model.content" @focus="inputFocus()" @blur="inputBlur" :rows="5"  placeholder="请输入模板内容"  ></a-textarea>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
      <div class="drawer-footer">
        <a-button @click="handleCancel" style="margin-bottom: 0;padding: 0 20px">关闭</a-button>
        <a-button @click="deleteTemplate" type="danger" v-if="model.id" style="margin-bottom: 0;padding: 0 20px;margin-left: 30px;">删除</a-button>
        <a-button  @click="handleOk"   type="primary" style="margin-bottom: 0;margin-left: 30px;padding: 0 20px">确定</a-button>
      </div>
    </div>
  </a-drawer>


</template>

<script>

  import { httpAction, getAction,deleteAction } from '@/api/manage'
  import {Modal} from "ant-design-vue";

  export default {
    name: 'AddTemplateModal',
    components: {

    },
    data () {
      return {
        title:"添加模板",
        width:540,
        visible: false,
        disableSubmit: false,
        confirmLoading:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        validatorRules: {
          templateName: [
            { required: true, message: '请输入模板名称!'},
          ],
          content: [
            { required: true, message: '请输入模板内容!'},
          ]
        },
        url: {
          add: "/dm/dmWorkOrderTemplate/add"
        },
        model:{
          content:''
        },
        toolList:[
          {
            label: '身份证号',
            value: '身份证号'
          },
          {
            label: '车牌号',
            value: '车牌号'
          },
          {
            label: '手机号',
            value: '手机号'
          },
          {
            label: '客户姓名',
            value: '客户姓名'
          },
          {
            label: '平台识别号',
            value: '平台识别号'
          }
        ],
        inputPosition:0
      }
    },created(){

    },
    methods: {
      add(businessSegment) {
        this.visible=true;
        this.model = {
          businessSegment:businessSegment,
          content:''
        };
      },edit(record){
        this.visible=true;
        this.model = JSON.parse(JSON.stringify(record));
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.form.validate(valid => {
          if (valid) {
            httpAction(this.url.add,this.model,"POST").then(res=>{
              if(res.success){
                this.$message.success(res.message);
                this.close();
                this.$emit('ok');
              }else{
                this.$message.error(res.message);
              }
            })
          }
        })
      },handleCancel(){
        this.close()
      },
      inputFocus() {
        let rect = null
        rect = this.$refs['titleRef'].getBoundingClientRect()
        this.$refs.toolRef.style.display = 'block'
        this.$refs.toolRef.style.top = rect.top - 30 + 'px'
        this.$refs.toolRef.style.left = rect.left + 'px'
      },
      inputBlur(val) {
        this.inputPosition = val.srcElement.selectionStart;
      },
      contentTap() {
        this.$refs.toolRef.style.display = 'none'
      },toolChange(e) {
        if(this.model.content){
          let ct = this.model.content;
          this.model.content = ct.substring(0, this.inputPosition) + '${' + e[0] + '}'
            + ct.substring(this.inputPosition)
        }else{
          this.model.content = '${' + e[0] + '}'
        }

      },deleteTemplate(){
        Modal.confirm( {
          title: '确定删除吗？删除后不可恢复',
          okText: '确定',
          cancelText: '取消',
          onOk: () => {
            deleteAction('/dm/dmWorkOrderTemplate/delete',{id:this.model.id}).then(res=>{
              if(res.success){
                this.$message.success("删除成功!");
                this.close();
                this.$emit('ok');
              }
            })
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>


.question-tool {
  position: fixed;
  left: 20px;
  top: 20px;
  z-index: 3;
  display: none;
  background: #fff;

  .tit {
    display: block;
    width: 56px;
    line-height: 20px;
    font-size: 12px;
    color: #8B8B8B;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    border: 1px solid #E6E6E6;
    border-radius: 4px;

    img {
      width: 12px;
      margin-right: 3px;
    }
  }
}

.drawer-footer{
  justify-content: center;
  display: flex;
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  left: 0;
  border-radius: 0 0 2px 2px;
  background: #fff;
}


</style>